import { render, staticRenderFns } from "./Ertiga2021.vue?vue&type=template&id=5ca65500&"
import script from "./Ertiga2021.vue?vue&type=script&lang=ts&"
export * from "./Ertiga2021.vue?vue&type=script&lang=ts&"
import style0 from "./Ertiga2021.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports